module.exports = __webpack_public_path__ + "static/media/image-card-9.1dd98339.png";